/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

/**
 * Pre-processes raw HTML from D365 before parsing.
 *
 * Normalises known legacy colour values carried over from old D365 inline styles
 * and strips empty non-breaking-space paragraphs that the new HTML standard
 * forbids but that may still appear in legacy product data during the transition.
 *
 * All other inline styles are left untouched — they will be ignored once the
 * data is fully remediated and cause no regression in the interim.
 */
export const preprocess = (html: string): string => {
  const replacements: { from: string; to: string }[] = [
    { from: "rgba(248, 108, 29, 1)", to: "#ac622a" },
    { from: "rgb(255, 102, 0)", to: "#ac622a" },
    { from: "<p>&nbsp;</p>", to: "" },
  ];

  return replacements.reduce((text, { from, to }) => text.replaceAll(from, to), html);
};
